import { FinishCheckoutPayload } from './cart-checkout.model';

export class FinishCheckoutAction {
  static readonly type = '[CartCheckout] Finish Cart Checkout';
  constructor(public payload: FinishCheckoutPayload) {}
}

export class ResetLoadingAction {
  static readonly type = '[CartCheckout] Reset Loading';
  constructor() {}
}
